import { useEffect, useState } from "react";
import { Text } from "src/components/ui/Text";
import { useTHPStore } from "src/context/stores";
import { useTranslation } from 'react-i18next'

const EvMenu = ({ selected = false, className }) => {
  let fill = selected ? "white" : "#1FA37C";
  return (
    <svg
      width="25"
      height="25"
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.77008 3.31991L6.43675 2.15325C6.15675 2.05325 5.85009 2.05325 5.57009 2.14658L2.91008 3.03991C2.37008 3.22658 2.00342 3.73325 2.00342 4.30658V12.2066C2.00342 13.1466 2.94342 13.7866 3.81675 13.4466L5.77008 12.6866C5.91675 12.6266 6.08342 12.6266 6.23008 12.6799L9.56342 13.8466C9.84342 13.9466 10.1501 13.9466 10.4301 13.8532L13.0901 12.9599C13.6301 12.7799 13.9968 12.2666 13.9968 11.6932V3.79325C13.9968 2.85325 13.0568 2.21325 12.1834 2.55325L10.2301 3.31325C10.0834 3.36658 9.92342 3.37325 9.77008 3.31991ZM10.0034 12.5932L6.00342 11.1866V3.40658L10.0034 4.81325V12.5932Z"
        fill={fill}
      />
      <path
        d="M9.77008 3.31991L6.43675 2.15325C6.15675 2.05325 5.85009 2.05325 5.57009 2.14658L2.91008 3.03991C2.37008 3.22658 2.00342 3.73325 2.00342 4.30658V12.2066C2.00342 13.1466 2.94342 13.7866 3.81675 13.4466L5.77008 12.6866C5.91675 12.6266 6.08342 12.6266 6.23008 12.6799L9.56342 13.8466C9.84342 13.9466 10.1501 13.9466 10.4301 13.8532L13.0901 12.9599C13.6301 12.7799 13.9968 12.2666 13.9968 11.6932V3.79325C13.9968 2.85325 13.0568 2.21325 12.1834 2.55325L10.2301 3.31325C10.0834 3.36658 9.92342 3.37325 9.77008 3.31991ZM10.0034 12.5932L6.00342 11.1866V3.40658L10.0034 4.81325V12.5932Z"
        fill={fill}
      />
    </svg>
  );
};

const EvMenuMap = ({ className, selected }) => {
  let fill = selected ? "white" : "#1FA37C";
  return (
    <svg
      width="25"
      height="25"
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 7.33333H6C6.73333 7.33333 7.33333 6.73333 7.33333 6V3.33333C7.33333 2.6 6.73333 2 6 2H3.33333C2.6 2 2 2.6 2 3.33333V6C2 6.73333 2.6 7.33333 3.33333 7.33333Z"
        fill={fill}
      />
      <path
        d="M3.33333 7.33333H6C6.73333 7.33333 7.33333 6.73333 7.33333 6V3.33333C7.33333 2.6 6.73333 2 6 2H3.33333C2.6 2 2 2.6 2 3.33333V6C2 6.73333 2.6 7.33333 3.33333 7.33333Z"
        fill="url(#paint0_linear_10557_11107)"
      />
      <path
        d="M3.33333 14H6C6.73333 14 7.33333 13.4 7.33333 12.6667V10C7.33333 9.26667 6.73333 8.66667 6 8.66667H3.33333C2.6 8.66667 2 9.26667 2 10V12.6667C2 13.4 2.6 14 3.33333 14Z"
        fill={fill}
      />
      <path
        d="M3.33333 14H6C6.73333 14 7.33333 13.4 7.33333 12.6667V10C7.33333 9.26667 6.73333 8.66667 6 8.66667H3.33333C2.6 8.66667 2 9.26667 2 10V12.6667C2 13.4 2.6 14 3.33333 14Z"
        fill="url(#paint1_linear_10557_11107)"
      />
      <path
        d="M8.66667 3.33333V6C8.66667 6.73333 9.26667 7.33333 10 7.33333H12.6667C13.4 7.33333 14 6.73333 14 6V3.33333C14 2.6 13.4 2 12.6667 2H10C9.26667 2 8.66667 2.6 8.66667 3.33333Z"
        fill={fill}
      />
      <path
        d="M8.66667 3.33333V6C8.66667 6.73333 9.26667 7.33333 10 7.33333H12.6667C13.4 7.33333 14 6.73333 14 6V3.33333C14 2.6 13.4 2 12.6667 2H10C9.26667 2 8.66667 2.6 8.66667 3.33333Z"
        fill="url(#paint2_linear_10557_11107)"
      />
      <path
        d="M10 14H12.6667C13.4 14 14 13.4 14 12.6667V10C14 9.26667 13.4 8.66667 12.6667 8.66667H10C9.26667 8.66667 8.66667 9.26667 8.66667 10V12.6667C8.66667 13.4 9.26667 14 10 14Z"
        fill={fill}
      />
      <path
        d="M10 14H12.6667C13.4 14 14 13.4 14 12.6667V10C14 9.26667 13.4 8.66667 12.6667 8.66667H10C9.26667 8.66667 8.66667 9.26667 8.66667 10V12.6667C8.66667 13.4 9.26667 14 10 14Z"
        fill="url(#paint3_linear_10557_11107)"
      />
    </svg>
  );
};

export const EvCharge = ({ selected, className }) => {
  let fill = selected ? "white" : "#1FA37C";
  return (
    <svg
      className={className}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3955 3.25203H11.1647V0.918693C11.1647 0.794925 11.108 0.676227 11.007 0.58871C10.906 0.501193 10.7691 0.452026 10.6263 0.452026C10.4835 0.452026 10.3465 0.501193 10.2455 0.58871C10.1445 0.676227 10.0878 0.794925 10.0878 0.918693V3.25203H5.78011V0.918693C5.78011 0.794925 5.72338 0.676227 5.6224 0.58871C5.52142 0.501193 5.38446 0.452026 5.24165 0.452026C5.02559 0.452026 4.70319 0.584443 4.70319 0.950193V3.25203H1.50944C1.08742 3.25203 0.93396 3.53086 0.93396 3.71869C0.93396 3.84246 0.990691 3.96116 1.09167 4.04868C1.19265 4.13619 1.32961 4.18536 1.47242 4.18536H2.54934V9.31869C2.54934 9.93753 2.833 10.531 3.3379 10.9686C3.84281 11.4062 4.52761 11.652 5.24165 11.652H7.3955V13.9854C7.3955 14.1091 7.45223 14.2278 7.55321 14.3153C7.65419 14.4029 7.79115 14.452 7.93396 14.452C8.07677 14.452 8.21373 14.4029 8.31471 14.3153C8.41569 14.2278 8.47242 14.1091 8.47242 13.9854V11.652H10.6263C11.3403 11.652 12.0251 11.4062 12.53 10.9686C13.0349 10.531 13.3186 9.93753 13.3186 9.31869V4.18536H14.3955C14.5383 4.18536 14.6753 4.13619 14.7762 4.04868C14.8772 3.96116 14.934 3.84246 14.934 3.71869C14.934 3.59493 14.8772 3.47623 14.7762 3.38871C14.6753 3.30119 14.5383 3.25203 14.3955 3.25203ZM9.51502 7.61594L8.70733 9.48261C8.65716 9.59864 8.55587 9.69265 8.42573 9.74396C8.29559 9.79527 8.14727 9.79967 8.01338 9.75619C7.8795 9.71272 7.77103 9.62493 7.71183 9.51215C7.65263 9.39936 7.64755 9.27081 7.69771 9.15478L8.23617 7.91869H6.85704C6.77003 7.91869 6.68431 7.90041 6.60723 7.86543C6.53016 7.83044 6.46401 7.77979 6.41445 7.71781C6.3649 7.65582 6.33341 7.58435 6.32269 7.50952C6.31198 7.43468 6.32234 7.35871 6.3529 7.28811L7.16059 5.42144C7.21076 5.30541 7.31205 5.2114 7.44219 5.16009C7.57233 5.10879 7.72065 5.10439 7.85454 5.14786C7.98842 5.19133 8.09689 5.27912 8.15609 5.39191C8.21529 5.50469 8.22037 5.63324 8.17021 5.74928L7.63175 6.98536H9.01088C9.09789 6.98536 9.18361 7.00364 9.26069 7.03862C9.33776 7.07361 9.40391 7.12426 9.45347 7.18625C9.50302 7.24823 9.53451 7.3197 9.54523 7.39453C9.55595 7.46937 9.54558 7.54534 9.51502 7.61594Z"
        fill={fill}
      />
    </svg>
  );
};

const EvMenuBtn = ({type }) => {
  const {mapView, infoView, setMapView, setInfoView} = useTHPStore()
  const { t } = useTranslation("widget");
  // const [selectedBtn, setSelectedBtn] = useState(
  //   type === "map" ? "Map View" : "truck"
  // );

  // const handleTabChange = (type) => {
  //   setSelectedBtn(type);
  //   setView(type);
  // };

  return (
    <>
      {type === "map" && (
        <div className="inline-flex items-center justify-end gap-2">
          <Text variant="semi-12" className="text-vekin-green100">
            {mapView}
          </Text>
          <div className="flex px-[0.195rem] py-[0.195rem] space-x-1 border rounded-full bg-vekin-green-50">
            <button
              onClick={() => setMapView("Map View")}
              type="button"
              className={
                mapView === "Map View" ? "bg-vekin rounded-full p-1" : "p-1"
              }
            >
              <EvMenu
                selected={mapView === "Map View"}
                className="w-4 h-4"
              />
            </button>
            <button
              onClick={() => setMapView("Grid View")}
              type="button"
              className={
                mapView === "Grid View"
                  ? "bg-vekin rounded-full p-1"
                  : "p-1"
              }
            >
              <EvMenuMap
                selected={mapView === "Grid View"}
                className="w-4 h-4"
              />
            </button>
          </div>
        </div>
      )}
      {type === "info" && (
        <div className="flex px-[0.195rem] py-[0.195rem] space-x-1 border rounded-full bg-vekin-green-50">
          <button
            onClick={() => setInfoView("truck")}
            type="button"
            className={
              infoView === "truck" ? "bg-vekin rounded-full px-1" : "px-1"
            }
          >
            <span
              className={`text-[13px]  rounded-full  ${
                infoView === "truck" ? "text-white " : " text-[#1FA37C]"
              }`}
            >
              EV
            </span>
          </button>
          <button
            onClick={() => setInfoView("charger")}
            type="button"
            className={
              infoView === "charger" ? "bg-vekin rounded-full p-1" : "p-1"
            }
          >
            <EvCharge
              selected={infoView === "charger"}
              className="w-4 h-4"
            />
          </button>
        </div>
      )}
    </>
  );
};

export default EvMenuBtn;
